export default __webpack_public_path__ + "static/media/5 of a Kind.ccdd5548.mp3";